import { z } from 'zod';
import { userTypesSimpleSchema } from '../../common';
import { nameSchema, objectIdSchema } from '../../validation';
import { userOrganizationSchema } from '../user';

//* event type
export const locationTrackingUserSchema = z.object({
  /** the user Id ... this will be coming from `User` collection */
  userId: objectIdSchema,
  /** the driver id coming from the `Driver` collection.
   *
   * It's optional because not always we will track driver location, we will track customer/carrier location also,
   *
   * and these types of users don't have driverIds.
   */
  driverId: objectIdSchema.optional(),

  /** the simple user type:
   * - `business_customer` =  any business customer user
   * - `carrier_company` =  any carrier company user `EXCEPT` drivers
   * - `individual_customer` = individual customer
   * - `carrier_company_driver` =  a driver works for a carrier company
   * - `freelancer_driver` =  a driver works as a freelancer without a company
   */
  type: userTypesSimpleSchema,

  /** the user display name */
  name: nameSchema,

  /** the organizations that the user belongs to.
   *
   * This cloud be an empty array when we track individual users such as freelancer driver, or individual customer
   */
  orgs: z.array(userOrganizationSchema),
});
export type LocationTrackingUserSchema = z.infer<typeof locationTrackingUserSchema>;
